unable to read source [project]/node_modules/src/storage.ts